jQuery(document).ready(function ($) {
  $(window).on('scroll', function () {
    if ($(window).scrollTop() > 50) {
      $('body').addClass('float_active');
    } else {
      $('body').removeClass('float_active');
    }
  });

  $(document).on('click', '#menu_trigger', function (event) {
    event.preventDefault();

    if ($('body').hasClass('menu_open')) {
      $('body').removeClass('menu_open');
    } else {
      $('body').addClass('menu_open');
    }
  });

  $('.smooth_scroll').click(function (event) {
    event.preventDefault();
    var margintop = $(this).data('mtop') ? $(this).data('mtop') : 100;

    if ($(this.hash).length > 0) {
      $('html,body').animate({ scrollTop: $(this.hash).offset().top - margintop }, 1200);
    } else {
      var getUrl = window.location,
        url = getUrl.protocol + '//' + getUrl.host + '/' + this.hash;
      window.location = url;
    }
  });

  //popup_form
  $(document).on('click', 'a[href^="#popup_"]', function (event) {
    event.preventDefault();
    var popup = $(this).attr('href').replace('#popup_', '');
    $('#' + popup).addClass('active');
  });

  $(document).on('click', '[data-close-popup]', function (event) {
    event.preventDefault();
    var popup = $(this).closest('.popup_form');
    $(popup).removeClass('active');
  });

  //PRODUCTS CAROUSEL
  const swiper = new Swiper('.products_carousel', {
    slidesPerView: 1,
    spaceBetween: 20,
    navigation: {
      prevEl: '.carousel_nav_item_prev',
      nextEl: '.carousel_nav_item_next',
    },
    breakpoints: {
      0: {
        slidesPerView: 1.5,
        spaceBetween: 20,
        centeredSlides: true,
      },
      640: {
        slidesPerView: 2.5,
        spaceBetween: 20,
      },
      992: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
    },
  });

  //testimonials_carousel
  const testimonials_carousel = new Swiper('.testimonials_carousel', {
    slidesPerView: 1,
    spaceBetween: 20,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 20,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
      },
      992: {
        slidesPerView: 1.6,
        spaceBetween: 30,
        slidesOffsetBefore: 60,
        slidesOffsetAfter: 60,
      },
    },
  });

  //video_popup
  $('.video_popup').magnificPopup({
    type: 'iframe',
    iframe: {
      preloader: false,
    },
  });

  //sort_by_trigger
  $(document).on('click', '.sort_by_trigger', function (event) {
    event.preventDefault();
    var dropdown = $(this).next('.sort_by_dropdown');
    if ($(dropdown).hasClass('open')) {
      $(dropdown).removeClass('open');
    } else {
      $(dropdown).addClass('open');
    }
  });

  /*** PRODUCT PAGE ***/
  const product_gallery_slider = new Swiper('.product_gallery_slider', {
    slidesPerView: 1,
    spaceBetween: 20,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  });

  //[data-gallery-thumb]
  $(document).on('click', '[data-gallery-thumb]', function () {
    var index = $(this).data('gallery-thumb');
    product_gallery_slider.slideTo(index);
  });

  //faq_item_header
  $(document).on('click', '.faq_item_header', function () {
    var item = $(this).closest('.faq_item'),
      content = $(item).find('.faq_item_content');

    if ($(item).hasClass('open')) {
      $(item).removeClass('open');
      $(content).slideUp();
    } else {
      $(item).addClass('open');
      $(content).slideDown();
    }
  });

  //qty_plus
  $(document).on('click', '.qty_plus', function () {
    var qty = $(this).prev('.quantity-selector'),
      value = parseInt($(qty).val()),
      max = $(qty).attr('max') ? parseInt($(qty).attr('max')) : 10;

    if (value < max) {
      $(qty)
        .val(value + 1)
        .change();
    }
  });

  //qty_minus
  $(document).on('click', '.qty_minus', function () {
    var qty = $(this).next('.quantity-selector'),
      value = parseInt($(qty).val());

    if (value > 1) {
      $(qty)
        .val(value - 1)
        .change();
    }
  });

  //reorder_form
  $(document).on('submit', '#reorder_form', function (e) {
    e.preventDefault();
    
    var form = $(this),
        form_data = $(form).serializeJSON(),
        ajax_url = 'https://api.icepick.co/bamboo_stickers/index.php';

    $.ajax({
      type: 'POST',
      url: ajax_url,
      data: {
        action: 'gw_getOrderProducts',
        form_data: form_data,
      },
      beforeSend: function () {
        $(form).addClass('loading');
      },
      success: function (response) {
        var response = JSON.parse(response);
        
        $(form).removeClass('loading');

        console.log(response);
        if (response.status != 'success') {
          alert(response.message);
          return false;
        }
        
        $.each(response.items, function(index, element) {
          if(element.id === 0 || element.id == null) {
            response.items.splice(index, 1);
          }
        });
        
        add_data = {
            "items": response.items
        };

        $.post('/cart/add.js', add_data)
        .done((response) => {
          $.fn.updateCart();
          $('body').addClass('cart_open');
        })
        .fail((xhr, status, error) => {
          console.error('Error adding the product to the cart:', error);
        });
      },
    });
  });

  //html_video_play
  $(document).on('click', '.html_video_wrapper', function () {
    if($(this).hasClass('playing')){
      $(this).removeClass('playing');
    }else{
      $(this).addClass('playing');
    }
  });

  //calculator_button
  $(document).on('click', '.calculator_button', function () {
    var stickers = parseInt($('.stickers_needed').val());

    // Plastic waste calculation
    var plastic_waste_lbs = ((stickers * 2) / 453.6).toFixed(2);
    $('[data-environmental-plastic]').text(plastic_waste_lbs);
    
    // CO2 reduced calculation
    var co2_reduced = (stickers * 2 * 0.001 * 2.5).toFixed(2);
    $('[data-environmental-co2]').text(co2_reduced); // Note: was using plastic_waste_lbs instead of co2_reduced
    
    // Trees equivalent calculation
    var trees_equivalent = (co2_reduced / 22).toFixed(2);
    $('[data-environmental-trees]').text(trees_equivalent);

    console.log();
  });
});
